import { BCKSInvitationCollectionPage } from 'app/BCKSPage/Invitation/collection'
import { fetchCartoolPageContentManager } from 'utils/cartoolContentManager'
import { isToggleEnabled } from 'configs/toggle-feature'
import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'

import type { CartoolContentManagerPayloadType } from 'utils/cartoolContentManager'
import type { PMMKSInvitationPageContentType } from 'app/BCKSPage/Invitation/ModelBCKSContentPage'

interface PropsInvitationCollectionPage extends PMMKSInvitationPageContentType {
  isKSSelectionEnabled: boolean
}

export async function getServerSideProps() {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')
  const cartoolContentPayload: CartoolContentManagerPayloadType = {
    pageName: 'PMMKSInvitationPage',
  }

  const { textContent, dataContent } = await fetchCartoolPageContentManager(
    cartoolContentPayload
  )

  return {
    props: {
      isKSSelectionEnabled,
      textContent,
      dataContent,
    },
  }
}

const BCKSInvitationCollectionIndexPage = (
  props: PropsInvitationCollectionPage
) => {
  const { textContent, dataContent } = props
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return (
    <BCKSInvitationCollectionPage
      textContent={textContent}
      dataContent={dataContent}
    />
  )
}

// eslint-disable-next-line react/display-name
BCKSInvitationCollectionIndexPage.Layout = ({ children }) => children

export default BCKSInvitationCollectionIndexPage
